import React, { useEffect, useState } from 'react';
import { Container, Form, Header, Icon, Breadcrumb, Button, Grid, Placeholder, Segment, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { useHistory, useLocation, useParams } from 'react-router';
import { usePublicCASASTestingForm } from './usePublicCASASTestingForm';
import moment from 'moment';

export function PublicCASASTestingForm() {
    let { WId } = useParams<{ WId: string }>();
    let [values, masterData, errors, touched, isLoading, isSubmitting, isValid, submitSuccess, errorMessage, registerRef, handleChange, handleBlur, handleSubmit] = usePublicCASASTestingForm();
    const history = useHistory();
    //console.log(masterData);

    function handleBackToList() {
        history.push('/');
    }

    return <Container className='providers-container'>
        <Header as='h1' style={{ marginTop: '2.0rem', marginBottom: '0.5rem' }}>Register CASAS Testing</Header>
        <hr style={{ marginBottom: '1.0rem' }} />
        <Breadcrumb style={{ marginBottom: '1.0rem' }}>
            <Breadcrumb.Section link><Link to='/'>Home</Link></Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section active>Register CASAS Testing</Breadcrumb.Section>
        </Breadcrumb>


        <Grid columns={2} style={submitSuccess ? { margin: 0 } : {}}>
            {
                !submitSuccess &&
                <>
                    <Grid.Column>
                        <Form loading={isSubmitting}>
                            <Form.Input className={!(!errors.firstName || !touched.firstName) ? 'mb-0' : ''}
                                required
                                fluid
                                label='First Name'
                                onChange={(event, data) => {
                                    handleChange(data.value, 'firstName');
                                }}
                                onBlur={
                                    () => { handleBlur('firstName') }
                                }
                                error={!(!errors.firstName || !touched.firstName) ? true : false}
                            />
                            {
                                !(!errors.firstName || !touched.firstName) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.firstName}</div>
                            }
                            <Form.Input className={!(!errors.lastName || !touched.lastName) ? 'mb-0' : ''}
                                required
                                fluid
                                label='Last Name'
                                onChange={(event, data) => {
                                    handleChange(data.value, 'lastName');
                                }}
                                onBlur={
                                    () => { handleBlur('lastName') }
                                }
                                error={!(!errors.lastName || !touched.lastName) ? true : false}
                            />
                            {
                                !(!errors.lastName || !touched.lastName) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.lastName}</div>
                            }

                            <Form.Input className={!(!errors.email || !touched.email) ? 'mb-0' : ''}
                                required
                                fluid
                                label='Email Address'
                                onChange={(event, data) => {
                                    handleChange(data.value, 'email');
                                }}
                                onBlur={
                                    () => { handleBlur('email') }
                                }
                                error={!(!errors.email || !touched.email) ? true : false}
                            />
                            {
                                !(!errors.email || !touched.email) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.email}</div>
                            }
                            <Form.Input className={!(!errors.confirmEmail || !touched.confirmEmail) ? 'mb-0' : ''}
                                required
                                fluid
                                label='Confirm Email Address'
                                onChange={(event, data) => {
                                    handleChange(data.value, 'confirmEmail');
                                }}
                                onBlur={
                                    () => { handleBlur('confirmEmail') }
                                }
                                error={!(!errors.confirmEmail || !touched.confirmEmail) ? true : false}
                            />
                            {
                                !(!errors.confirmEmail || !touched.confirmEmail) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.confirmEmail}</div>
                            }
                            <Form.Input className={!(!errors.phoneNumber || !touched.phoneNumber) ? 'mb-0' : ''}

                                fluid
                                label='Phone Number'
                                onChange={(event, data) => {
                                    handleChange(data.value, 'phoneNumber');
                                }}
                                onBlur={
                                    () => { handleBlur('phoneNumber') }
                                }
                                error={!(!errors.phoneNumber || !touched.phoneNumber) ? true : false}
                            />
                            {
                                !(!errors.phoneNumber || !touched.phoneNumber) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.phoneNumber}</div>
                            }
                            <Form.TextArea className={!(!errors.counselorComments || !touched.counselorComments) ? 'mb-0' : ''}
                                fluid
                                label='Comments'
                                onChange={(event, data) => {
                                    handleChange(data.value, 'counselorComments');
                                }}
                                onBlur={
                                    () => { handleBlur('counselorComments') }
                                }
                                error={!(!errors.counselorComments || !touched.counselorComments) ? true : false}
                            />
                            {
                                !(!errors.counselorComments || !touched.counselorComments) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.counselorComments}</div>
                            }
                            <Button type='button' loading={isSubmitting} primary onClick={handleSubmit}>Submit</Button>
                            <Button type='button' onClick={() => { history.push('/') }}>Cancel</Button>
                        </Form>
                        <Message info>
                            <p>
                                The RSA Staff will receive an email notification after this form has been submitted.
                            </p>
                        </Message>
                    </Grid.Column>
                    <Grid.Column>
                    </Grid.Column>
                </>
            }
            {
                submitSuccess &&
                <Message icon positive>
                    <Icon name='check circle outline' color='green' />
                    <Message.Content>
                        <Message.Header>Success</Message.Header>
                        <div>You have successfully registered your client for CASAS Testing.</div>
                        <div style={{ marginTop: '0.5rem' }}>
                            <Button icon labelPosition='left' size='small' onClick={handleBackToList}>
                                <Icon name='arrow circle left' />
                                <span>Back to Home page</span>
                            </Button></div>
                    </Message.Content>
                </Message>
            }

        </Grid>

    </Container>
}